import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
// /** @jsxRuntime classic */
// /** @jsx jsxCustomEvent */
// import jsxCustomEvent from "@micro-zoe/micro-app/polyfill/jsx-custom-event";
import microApp from "@micro-zoe/micro-app";
import { useDeferredValue, useEffect, useState } from "react";
import { generatePath, matchRoutes, useLocation } from "react-router-dom";
import { Result } from "antd";
import { getChildPathname } from "../../../utils";
import { useMicroAppEventHandle } from "../../hooks/useMicroAppEventHandle";
import { routesArraySelector, sendMessage, useAppStore, useMicroAppStore } from "../../../store";
import ContainerRender from "./ContainerRender";
import { NoAccessPlaceholder } from "../NoAccessPlaceholder";
import { NoFoundPlaceholder } from "../NoFoundPlaceholder";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function isLoading(status) {
  return ["created", "initialized", "beforemount"].includes(status);
}
var mountedDefferMap = new Map();
var MicroAppContainer = function MicroAppContainer(_ref) {
  var layoutConfig = _ref.layoutConfig;
  var noCache = layoutConfig.tabsMode === false;
  var microApps = useMicroAppStore(function (s) {
    return s.microApps;
  });
  var setActivated = useMicroAppStore(function (s) {
    return s.setActivated;
  });
  var setStatus = useMicroAppStore(function (s) {
    return s.setStatus;
  });
  var flatPathRoutes = useAppStore(function (s) {
    return s.flatPathRoutes;
  });
  var monitorConfig = useAppStore(function (s) {
    return s.monitorConfig;
  });
  var routesPaths = useAppStore(routesArraySelector);
  var menus = useAppStore(function (s) {
    return s.menus;
  });
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname,
    search = _useLocation.search;
  var defPathname = useDeferredValue(pathname);
  var defSearch = useDeferredValue(search);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    noAccess = _useState2[0],
    setNoAccess = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    notFound = _useState4[0],
    setNotFound = _useState4[1];
  var microAppActivated = useMicroAppStore(function (s) {
    return s.microApps.some(function (el) {
      return el.activated;
    });
  });

  // 提前响应，避免切换的时候页面一闪而过
  useEffect(function () {
    if (!microAppActivated) {
      setNoAccess(null);
      setNotFound(null);
    }
  }, [microAppActivated]);
  var handleMicroAppLoad = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _ref3, _ref4, matchRoute, realMatchRoute, mapPathname, currentApp, _panes, route, res, realSubPathname, childPathname, currentAppName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref3 = matchRoutes(routesPaths, defPathname || "") || [], _ref4 = _slicedToArray(_ref3, 1), matchRoute = _ref4[0];
            if (matchRoute) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            realMatchRoute = flatPathRoutes[matchRoute.route.path]; // 主应用与子应用path不一致
            mapPathname = (realMatchRoute === null || realMatchRoute === void 0 ? void 0 : realMatchRoute.microAppPath) || defPathname;
            currentApp = microApps.find(function (app) {
              return mapPathname.startsWith(app.baseRoute);
            });
            if (currentApp) {
              _context.next = 10;
              break;
            }
            setActivated(void 0);
            setNoAccess(null);
            return _context.abrupt("return");
          case 10:
            _panes = useAppStore.getState().panes;
            route = _panes.find(function (pane) {
              return pane.path === mapPathname || pane.dynamicMicroAppPath === mapPathname;
            });
            if (!(!route || (route === null || route === void 0 ? void 0 : route.id) === "@@404")) {
              _context.next = 19;
              break;
            }
            setActivated(void 0);
            setNoAccess(null);
            setNotFound( /*#__PURE__*/_jsx(NoFoundPlaceholder, {
              layoutConfig: layoutConfig
            }));
            return _context.abrupt("return");
          case 19:
            setNotFound(null);
          case 20:
            if (!layoutConfig.canAccess) {
              _context.next = 28;
              break;
            }
            _context.next = 23;
            return layoutConfig.canAccess({
              route: route,
              routes: flatPathRoutes,
              menus: menus
            });
          case 23:
            res = _context.sent;
            if (res) {
              _context.next = 28;
              break;
            }
            setNoAccess( /*#__PURE__*/_jsx(NoAccessPlaceholder, {
              layoutConfig: layoutConfig,
              route: route
            }));
            setActivated(currentApp === null || currentApp === void 0 ? void 0 : currentApp.name);
            return _context.abrupt("return");
          case 28:
            // activate app
            setActivated(currentApp === null || currentApp === void 0 ? void 0 : currentApp.name);
            setNoAccess(null);
            realSubPathname = matchRoute.route.microAppPath ? generatePath(matchRoute.route.microAppPath, matchRoute.params) : mapPathname;
            childPathname = getChildPathname(realSubPathname, currentApp.baseRoute);
            currentAppName = currentApp.name;
            if (!(currentApp.status === "uninitialized")) {
              _context.next = 37;
              break;
            }
            setStatus(currentAppName, "initialized");
            // 延迟处理pathname变更通知,由于是初始化内容，把应用相关参数也传递进去，让子应用可以进行桥接monitor配置
            mountedDefferMap.set(currentAppName, function ($pathname, $search) {
              var realSubPathname = matchRoute.route.microAppPath ? generatePath(matchRoute.route.microAppPath, matchRoute.params) : $pathname;
              var targetAppPathname = getChildPathname(realSubPathname, currentApp.baseRoute);
              sendMessage(currentAppName, {
                event: "pathnameChanged",
                data: {
                  pathname: targetAppPathname,
                  search: $search,
                  extra: {
                    app: currentApp,
                    parentMonitor: monitorConfig,
                    keepAlive: !noCache
                  }
                }
              });
            });
            return _context.abrupt("return");
          case 37:
            sendMessage(currentAppName, {
              event: "pathnameChanged",
              data: {
                pathname: childPathname,
                search: search,
                extra: {
                  app: currentApp,
                  parentMonitor: monitorConfig
                }
              }
            });
          case 38:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleMicroAppLoad() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    handleMicroAppLoad();
  }, [defPathname, defSearch]);
  useEffect(function () {
    // 运行延迟处理通知
    microApps.forEach(function (app) {
      if (app.status === "mounted" && mountedDefferMap.has(app.name)) {
        var _ref5 = matchRoutes(routesPaths, pathname || "") || [],
          _ref6 = _slicedToArray(_ref5, 1),
          matchRoute = _ref6[0];
        var subPath = generatePath(matchRoute.route.microAppPath || matchRoute.route.path, matchRoute.params);
        // 主应用与子应用path不一致
        mountedDefferMap.get(app.name)(subPath, search);
        mountedDefferMap.delete(app.name);
      }
    });
  }, [microApps]);
  useMicroAppEventHandle(microApp);
  return /*#__PURE__*/_jsxs("div", {
    className: "sa-micro-app-container-hook",
    children: [noAccess, notFound, microApps.map(function (app) {
      if (["uninitialized", "unmount"].includes(app.status)) {
        return null;
      }
      if (app.status === "error") {
        return app.activated ? /*#__PURE__*/_jsx(Result, {
          status: "error",
          title: "".concat(app.name, "@").concat(app.url, " load error.")
        }, app.name) : null;
      }
      var compatibleProps = app.compatible === "memory" ? {
        "disable-memory-router": true
      } : {
        "router-mode": "pure"
      };
      var $isLoading = isLoading(app.status);
      var $display = app.activated && !noAccess && !notFound ? "block" : "none";
      return /*#__PURE__*/_jsx("div", {
        style: {
          display: $display
        },
        children: /*#__PURE__*/_jsx(ContainerRender, {
          app: app,
          isLoading: $isLoading,
          children: /*#__PURE__*/_jsx("micro-app", _objectSpread(_objectSpread({
            name: app.name,
            "clear-data": true,
            baseroute: app.baseRoute,
            url: app.url
          }, compatibleProps), app.microAppConfig))
        })
      }, app.name);
    })]
  });
};
export default MicroAppContainer;